import { render } from "./info.vue?vue&type=template&id=8bcbde2c&scoped=true"
import script from "./info.vue?vue&type=script&lang=js"
export * from "./info.vue?vue&type=script&lang=js"

import "./info.vue?vue&type=style&index=0&id=8bcbde2c&scoped=true&lang=scss"

import exportComponent from "D:\\project\\pc\\website\\node_modules\\_vue-loader@16.8.3@vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8bcbde2c"]])

export default __exports__